import { ManfrediteOfferFilterCreateRequest } from './manfredite-offer-filter-create.request';
export const createMockedManfrediteOfferFilterRequest = (customValues = {}) => {
    const request = new ManfrediteOfferFilterCreateRequest();
    request.lang = customValues.lang ?? 'ES';
    request.currency = customValues.currency ?? '€';
    request.offerLanguage = customValues.offerLanguage ?? 'EN';
    request.minSalary = customValues.minSalary ?? 10000;
    request.text = customValues.text ?? 'frontend';
    request.remoteOptions = customValues.remoteOptions ?? ['remote'];
    request.locations = customValues.locations ?? ['placeId-1234'];
    request.techs = customValues.techs ?? [1];
    request.techRoles = customValues.techRoles ?? [1];
    request.minLanguages = customValues.minLanguages ?? [{ languageId: 1, level: 'Fluent' }];
    return request;
};
//# sourceMappingURL=manfredite-offer-filter-create.request.mock.js.map